import { request } from '@/utils/request'

export const ProviderJobRoleService = {
    ignore(id) {
        return request.delete(`/api/manage/provider-job-roles/${id}`)
    },
}
